// in src/Item.js
import Grid from "@mui/material/Grid";

const Item = (props) => {
  return <Grid xs={12} sm={4} md={3} {...props} item />;
};

export default Item;
